// / Sentry
import sentry from './modules/sentry.js'
sentry()

// Dependencies
import { _ } from './utils.js'

import forgottenPasswordHider from './modules/forgotten-password.js'
forgottenPasswordHider()

const modulesOnLoad = {
    'dropmenu': _('dropmenu').nodes(),
    'dynamics-form': _('dynamics-form', 'element').nodes(),
    'jargon-buster': _('jargon-buster').nodes(),
    'listing': _('listing').nodes(),
    'login-form': _('login-form').nodes(),
    'mobile-nav': _('mobile-nav').nodes(),
    'modal': _('modal').nodes(),
    'navbar': _('navbar').nodes(),
    'tabs': _('tab-trigger').nodes(),
    'video': _('video', 'element').nodes(),
}

for (const [fileName, nodes] of Object.entries(modulesOnLoad)) {
    if (nodes.length) {
        import(`./modules/${fileName}.js`)
            .then((module) => {
                nodes.forEach((el) => {
                    module.default(el)
                })
            })
            .catch((error) => {
                console.error(fileName, error)
            })
    }
}
